import { gql, useMutation } from "@apollo/client";
import React from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router";
import { FormError } from "../components/form-error";
import { createPodcastMutation, createPodcastMutationVariables } from "../__generated__/createPodcastMutation";

interface ICreatePodcastForm {
  title: string;
  description: string;
  categoryName: string;
}

const CREATE_PODCAST_MUTATION = gql`
  mutation createPodcastMutation($createPodcastInput: CreatePodcastInput!) {
    createPodcast(input: $createPodcastInput) {
      ok
      error
    }
  }
`;

export const CreatePodcast = () => {
  const { register, handleSubmit, getValues, formState } = useForm<ICreatePodcastForm>({
    mode: "onChange",
  });
  const onSubmit = () => {
    const { title, description, categoryName } = getValues();
    if (!loading) {
      createPodcastMutation({
        variables: {
          createPodcastInput: {
            title,
            description,
            categoryName,
          },
        },
      });
    }
  };
  const history = useHistory();
  const onCompleted = (data: createPodcastMutation) => {
    const {
      createPodcast: { ok },
    } = data;
    if (ok) {
      history.push("/manage-podcasts");
    }
  };
  const [createPodcastMutation, { loading, data: createPodcastMutationResult }] = useMutation<
    createPodcastMutation,
    createPodcastMutationVariables
  >(CREATE_PODCAST_MUTATION, {
    onCompleted,
  });

  return (
    <div className="h-screen bg-black text-white">
      <Helmet>
        <title>Create Podcast | Pocast</title>
      </Helmet>
      <div className="flex flex-col justify-center items-center text-center pt-10">
        <div className="w-full max-w-screen-sm px-5 text-center flex flex-col justify-between ">
          <div className="relative mb-24 mr-auto">
            <div className="text-left text-3xl tracking-wider leading-10 pb-1 text-purple-700">Create Podcast</div>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="grid gap-3 mt-5  sm:w-96 sm:mx-auto  mb-5 z-10">
            <div className="text-left flex flex-col">
              <label className="mb-2 pl-2 font-bold text-white">Title</label>
              <input
                {...register("title", {
                  required: "Title is required",
                })}
                name="title"
                placeholder="Title"
                autoComplete="off"
                className="rounded-lg p-2 border-2 bg-transparent text-lg bg-gray-900 border-purple-200 transition-colors focus:outline-none focus:border-purple-700 mb-1"
              />
              {formState.errors.title?.message && <FormError errorMessage={formState.errors.title?.message} />}
            </div>
            <div className="text-left flex flex-col">
              <label className="mb-2 pl-2 font-bold text-white">Description</label>
              <textarea
                {...register("description", { required: "Description is required" })}
                name="description"
                placeholder="Description"
                className="rounded-lg focus:outline-none focus:border-purple-700  p-2 border-2 bg-transparent text-lg border-purple-200 transition-colors sm:w-96 sm:mx-auto mb-1 bg-gray-900"
              />
              {formState.errors.description?.message && <FormError errorMessage={formState.errors.description?.message} />}
            </div>
            <div className="text-left flex flex-col">
              <label className="mb-2 pl-2 font-bold text-white">Category</label>
              <input
                {...register("categoryName", {
                  required: "Category is required",
                })}
                name="categoryName"
                placeholder="Category"
                autoComplete="off"
                className="rounded-lg p-2 border-2 bg-transparent text-lg bg-gray-900 border-purple-200 transition-colors focus:outline-none focus:border-purple-700 mb-1"
              />
              {formState.errors.title?.message && <FormError errorMessage={formState.errors.title?.message} />}
            </div>
            <button
              className={`flex justify-center py-2 rounded-lg font-bold text-white tracking-wider sm:w-96 sm:mx-auto focus:outline-none bg-purple-700 hover:bg-purple-800 transition delay-75 ${
                loading ? "select-none" : ""
              }`}
            >
              {loading ? "Loading ..." : "Create Podcast"}
            </button>
            {createPodcastMutationResult?.createPodcast.error && (
              <FormError errorMessage={createPodcastMutationResult?.createPodcast.error} />
            )}
          </form>
        </div>
      </div>
    </div>
  );
};
